require('./bootstrap');

// let contactForm = document.getElementById('contact-form');
// if(contactForm) {
//     contactForm.addEventListener('submit', (e) => {
//         e.preventDefault();
//         var data = new FormData(contactForm);
//         var req = new XMLHttpRequest();
//         var action = contactForm.getAttribute('action');
//         req.open('POST',action,true);
//         req.send(data);
//         contactForm.closest('.block').querySelector('.success').classList.remove('d-none');
//         contactForm.classList.add('d-none');
//         contactForm.closest('.text-block').scrollIntoView({ block: 'center'});
//     });
// }
